var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"a-image a-image--fadeOnLoad",class:{ 'a-image--modal': _vm.modal }},[_c('img',{staticClass:"a-image__image",class:{'a-image__image--loaded': _vm.isLoaded, 'a-image__image--modal': _vm.modal, 'a-image__image--vertical': _vm.isVertical},attrs:{"src":_vm.src,"alt":_vm.alt},on:{"load":_vm.onLoad}})])
}
var staticRenderFns = []

export { render, staticRenderFns }